import { CrudField } from "./CrudField";
import { CrudModel } from "./CrudModel";

import { Conditional } from "./Conditional";
import { CrudLayout } from "./CrudLayout";
import { CrudProperty } from "./CrudProperty";

import * as conditionalComparers from "./conditional-comparers";
import * as conditionals from "./conditionals";
import * as fieldTypes from "./field-types";
import * as layouts from "./layouts";
import * as propertyTypes from "./property-types";
import validationRules from "./validation-rules";

import Rule from "./Rule";

/**
 * Populates every Cruxtify type registry (model types, field types, property
 * types, layouts, conditionals, rules) with no Vue import and no SFC pulled
 * in — a plain-Node context (a test, a script) can call this and instantiate
 * a model with no DOM. Vue.component() registration stays in crudConfig.ts's
 * initConfig(), which is the only caller that needs a Vue instance.
 */
export function registerCoreTypes(userCrudObjects) {
  // user models
  CrudModel.registerModelTypes({ ...userCrudObjects.crudModels });
  CrudField.registerCrudFieldTypes({ ...userCrudObjects.crudFields });

  // property types
  Object.keys(propertyTypes).forEach((propertyTypeName) => {
    CrudProperty.registerCrudPropertyType(
      propertyTypeName,
      propertyTypes[propertyTypeName]
    );
  });

  // field types
  Object.keys(fieldTypes).forEach((fieldTypeName) => {
    CrudField.registerCrudFieldType(fieldTypeName, fieldTypes[fieldTypeName]);
  });

  // layouts
  Object.keys(layouts).forEach((layoutName) => {
    CrudLayout.registerCrudLayoutType(layoutName, layouts[layoutName]);
  });

  // conditional comparers
  Conditional.registerConditionalTypes(conditionals);
  conditionals.CompareConditional.registerComparers(conditionalComparers);

  // rules
  Rule.registerRules(validationRules);
}
